
import React from 'react';
import { Button } from 'antd';

export const isImg = /^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?/;
export const getChildrenToRender = (item, i) => {
  let tag = item.name.indexOf('title') === 0 ? 'h1' : 'div';
  tag = item.href ? 'a' : tag;
  let children;
  
  // 检查是否是图片标签且children是data URL或匹配isImg
  if (item.name === 'image' && typeof item.children === 'string' && (item.children.match(isImg) || item.children.startsWith('data:image/'))) {
    // 处理图片标签的图片URL
    children = React.createElement('img', { src: item.children, alt: 'img' });
  } else if (typeof item.children === 'string' && (item.children.match(isImg) || item.children.startsWith('data:image/'))) {
    // 处理字符串形式的图片URL或data URL
    children = React.createElement('img', { src: item.children, alt: 'img' });
  } else {
    // 其他情况保持原样
    children = item.children;
  }
  
  if (item.name.indexOf('button') === 0 && typeof item.children === 'object') {
    children = React.createElement(Button, {
      ...item.children
    });
  }
  return React.createElement(tag, { key: i.toString(), ...item }, children);
};
